var _a, _b;
var styles = ({
    root: (_a = {},
        _a['& .ant-modal-close'] = {
            left: 0
        },
        _a),
    withoutFooter: (_b = {},
        _b['& .ant-modal-footer'] = {
            display: 'none'
        },
        _b)
});
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/styles.ts
// module id = 1342
// module chunks = 0